module.exports = __webpack_public_path__ + "img/monitorbox06.04c442ae.jpg";